import React from 'react';
import {
  boPhanSearchColumns,
  chiPhiKhongHopLeSearchColumns,
  dotThanhToanSearchColumns,
  hopDongSearchColumns,
  kheUocSearchColumns,
  lenhSanXuatSearchColumns,
  phiSearchColumns,
  vatTuSearchColumns,
  vuViecSearchColumns
} from '@/constants/search-columns';
import { BoPhan, DotThanhToan, HopDong, KheUoc, Phi, VatTu, VuViec } from '@/types/schemas';
import { SearchField } from '@/components/custom/erp';
import QUERY_KEYS from '@/constants/query-keys';
import { Label } from '@/components/ui/label';

const FilterByObjectTab: React.FC = () => {
  return (
    <div className='space-y-2 p-4' style={{ width: '800px', minWidth: '800px' }}>
      <div className='flex flex-col space-y-1'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Bộ phận:</Label>
          <SearchField<BoPhan>
            searchEndpoint={`/${QUERY_KEYS.BO_PHAN}/`}
            searchColumns={boPhanSearchColumns}
            dialogTitle='Danh mục bộ phận'
            columnDisplay='ma_bp'
            displayRelatedField='ten_bp'
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Vụ việc:</Label>
          <SearchField<VuViec>
            searchEndpoint={`/${QUERY_KEYS.VU_VIEC}/`}
            searchColumns={vuViecSearchColumns}
            dialogTitle='Danh mục vụ việc'
            columnDisplay='ma_vu_viec'
            displayRelatedField='ten_vu_viec'
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Hợp đồng:</Label>
          <SearchField<HopDong>
            searchEndpoint={`/${QUERY_KEYS.HOP_DONG}/`}
            searchColumns={hopDongSearchColumns}
            dialogTitle='Danh mục hợp đồng'
            columnDisplay='ma_hd'
            displayRelatedField='ten_hd'
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Đợt thanh toán:</Label>
          <SearchField<DotThanhToan>
            searchEndpoint={`/${QUERY_KEYS.DOT_THANH_TOAN}/`}
            searchColumns={dotThanhToanSearchColumns}
            dialogTitle='Danh mục đợt thanh toán'
            columnDisplay='ma_dtt'
            displayRelatedField='ten_dtt'
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Khế ước:</Label>
          <SearchField<KheUoc>
            searchEndpoint={`/${QUERY_KEYS.KHE_UOC}/`}
            searchColumns={kheUocSearchColumns}
            dialogTitle='Danh mục khế ước'
            columnDisplay='ma_ku'
            displayRelatedField='ten_ku'
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Phí:</Label>
          <SearchField<Phi>
            searchEndpoint={`/${QUERY_KEYS.PHI}/`}
            searchColumns={phiSearchColumns}
            dialogTitle='Danh mục phí'
            columnDisplay='ma_phi'
            displayRelatedField='ten_phi'
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Sản phẩm:</Label>
          <SearchField<VatTu>
            searchEndpoint={`/${QUERY_KEYS.VAT_TU}/`}
            searchColumns={vatTuSearchColumns}
            dialogTitle='Danh mục vật tư'
            columnDisplay='ma_vt'
            displayRelatedField='ten_vt'
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Lệnh sản xuất:</Label>
          <SearchField<BanHangRecord>
            searchEndpoint={`/`}
            searchColumns={lenhSanXuatSearchColumns}
            dialogTitle='Danh mục lệnh sản xuất'
            columnDisplay='so_lsx'
            displayRelatedField='description'
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>C/p không h/lệ:</Label>
          <SearchField
            searchEndpoint={`/${QUERY_KEYS.CHI_PHI_KHONG_HOP_LE}/`}
            searchColumns={chiPhiKhongHopLeSearchColumns}
            dialogTitle='Danh mục chi phí không hợp lệ'
            columnDisplay='ma_cpkhl'
            displayRelatedField='ten_cpkhl'
          />
        </div>
      </div>
    </div>
  );
};

export default FilterByObjectTab;
